export default "__VITE_ASSET__CZ0$TzGP__"